<template>
  <auth-shell>
    <auth-card
      ref="card"
      title="Вход в Комбу"
      description="Войдите в свой аккаунт, чтобы продолжить работу с организацией."
      error-id="signin-server-error"
      :error-message="authError"
      :loading="submitting"
      loading-message="Проверяем данные"
    >
      <q-form
        ref="form"
        class="auth-form"
        @submit.prevent="onSubmit"
        @validation-error="onValidationError"
      >
        <q-input
          v-model="email"
          outlined
          label="Email"
          type="email"
          name="email"
          autocomplete="email"
          :disable="submitting"
          :aria-describedby="authError ? 'signin-server-error' : undefined"
          :rules="emailRules"
        >
          <template #prepend><q-icon name="email" aria-hidden="true" /></template>
        </q-input>

        <password-input
          v-model="password"
          autocomplete="current-password"
          :disable="submitting"
          :describedby="authError ? 'signin-server-error' : ''"
          :rules="passwordRules"
        />

        <div class="auth-row">
          <q-checkbox v-model="rememberMe" :disable="submitting" label="Запомнить меня" />
          <q-btn flat no-caps color="primary" label="Восстановить пароль" :disable="submitting" :to="{ name: 'change_password' }" />
        </div>

        <q-btn
          unelevated
          no-caps
          color="primary"
          class="auth-submit"
          label="Войти"
          type="submit"
          :loading="submitting"
          :disable="submitting"
        />
      </q-form>

      <template #footer>
        <p>Нет аккаунта? <router-link :to="{ name: 'signup' }">Зарегистрироваться</router-link></p>
      </template>
    </auth-card>
  </auth-shell>
</template>

<script>
import axios from 'axios'
import { AuthCard, AuthShell, PasswordInput } from '../../components/auth'
import { apiUrl } from '../../config'
import { annotateValidationErrors } from '../../services/formValidation'

export default {
  name: 'login',
  components: { AuthCard, AuthShell, PasswordInput },
  data() {
    return {
      email: '',
      password: '',
      rememberMe: true,
      submitting: false,
      authError: '',
      emailRules: [
        (value) => Boolean(value) || 'Введите email',
        (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) || 'Неверный формат email'
      ],
      passwordRules: [(value) => Boolean(value) || 'Введите пароль']
    }
  },
  methods: {
    showError(message) {
      this.authError = message
      this.$refs.card.focusError()
    },
    onValidationError() {
      this.$nextTick(() => {
        const form = this.$refs.form && this.$refs.form.$el
        annotateValidationErrors(form)
        const firstInvalid = form && form.querySelector(
          '.q-field--error input, .q-field--error textarea, .q-field--error [tabindex]:not([tabindex="-1"])'
        )
        if (firstInvalid && typeof firstInvalid.focus === 'function') firstInvalid.focus()
      })
    },
    async onSubmit() {
      if (this.submitting) return
      this.submitting = true
      this.authError = ''
      try {
        const response = await axios.post(`${apiUrl}/user/token/request/`, {}, {
          auth: { username: this.email, password: this.password }
        })
        if (response.data.token === undefined) {
          this.password = ''
          this.showError('Не удалось войти. Повторите попытку.')
          return
        }
        this.connection.updateCredentials(this.$q, response.data.token, response.data.token_uuid, this.rememberMe)
        this.connection.makeConnection(this.$q)
        this.$router.push({ name: 'profile' })
        this.$q.notify({ color: 'positive', message: 'Вы успешно вошли в систему' })
        if (response.data.user_info) this.emitter.emit('receiveUserInfo', response.data.user_info)
      } catch {
        this.password = ''
        this.showError('Неверный email или пароль')
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style scoped>
.auth-row { display: flex; align-items: center; justify-content: space-between; gap: var(--sid-space-2); }
@media (max-width: 399px) { .auth-row { align-items: stretch; flex-direction: column; } }
</style>
